(function() {
    $.tmoapp= {
        info: function(content) {

            ShowDialog(content);

        },
      
        alert: function(content) {
            ShowDialog(content);
         
        },
        confirmResult: function(message, fnName) {
            BootstrapDialog.confirm(message, function(result) {
                if (result) {
                    fnName.call();
                }
                else {
                    return false;
                }
            });
        },
       getURLParameter: function(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        var i = 0;
        for (i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    },
        loadServerResource: function(path, method, data, handler,
        errorHandler, blockControl) {
           
            return $.ajax({
                type: method,
                url: path,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: data,
                error: function(result) {
                    $.tmoapp_common.error(result);
                    err_callback.fire(result);
                },
                complete: function(result) {
                    if (blockControl !== null && blockControl !== undefined) {
                        blockControl.unblock();
                    }
                }
            }).done(handler);
        }
 
    };
})();

function ShowDialog(message) {

    BootstrapDialog.alert(message);
}
;
